import { render, staticRenderFns } from "./orderCgPayment.vue?vue&type=template&id=b428ece6&scoped=true"
import script from "./orderCgPayment.vue?vue&type=script&lang=js"
export * from "./orderCgPayment.vue?vue&type=script&lang=js"
import style0 from "./orderCgPayment.vue?vue&type=style&index=0&id=b428ece6&prod&scoped=true&lang=scss"
import style1 from "./orderCgPayment.vue?vue&type=style&index=1&id=b428ece6&prod&lang=css"
import style2 from "./orderCgPayment.vue?vue&type=style&index=2&id=b428ece6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b428ece6",
  null
  
)

export default component.exports